// extracted by mini-css-extract-plugin
module.exports = {"years":"YearsView_years__pCl5l","fade-in":"YearsView_fade-in__sRsDF","fadeIn":"YearsView_fadeIn__L2zaX","description":"YearsView_description__dFg0_"};